import { SxProps } from '@mui/material';

export const ModalPaperSx: SxProps = {
  maxWidth: '1300px',
  '& div > #modal-button-stack': {
    marginBottom: '1rem',
  },
  height: '100vh',
};
